var _ref;
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { QUERY_PARAM_TERM_UPDATED } from '../actions/constants/ActionTypes';
import { validateRecurringTermOrGetDefault } from '../utils/validators';
const termFromQueryParam = getQueryParams().term;
const normalizedTerm = (_ref = Array.isArray(termFromQueryParam) ? termFromQueryParam[0] : termFromQueryParam) === null || _ref === void 0 ? void 0 : _ref.toLowerCase();
const initialState = validateRecurringTermOrGetDefault(normalizedTerm || 'annual');
const QueryParamTerm = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case QUERY_PARAM_TERM_UPDATED:
      return payload;
    default:
      return state;
  }
};
export default QueryParamTerm;